import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronRight, ShoppingCart } from 'lucide-react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PromoBanner = () => {
  const [banners, setBanners] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('dismissed_banners') || '[]'); } catch { return []; }
  });
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    axios.get(`${API_URL}/api/banners`).then(r => setBanners(r.data || [])).catch(() => {});
  }, []);

  const visible = banners.filter(b => !dismissed.includes(b.id));

  // Auto-rotate banners
  useEffect(() => {
    if (visible.length <= 1) return;
    const timer = setInterval(() => setCurrent(c => c + 1), 6000);
    return () => clearInterval(timer);
  }, [visible.length]);

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    try { sessionStorage.setItem('dismissed_banners', JSON.stringify(next)); } catch {}
  };

  if (visible.length === 0) return null;

  const banner = visible[current % visible.length];
  if (!banner) return null;

  const linkTo = banner.product_id ? `/produkte?highlight=${banner.product_id}` : banner.link;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-2">
      <AnimatePresence mode="wait">
        <motion.div key={banner.id} initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
          className="relative overflow-hidden rounded-xl" style={{ background: banner.bg_color || '#0094ff' }}
          data-testid="promo-banner">
          <div className="px-5 py-3 flex items-center justify-between gap-3">
            <div className="flex-1 min-w-0">
              <p className="font-bold text-sm" style={{ color: banner.text_color || '#fff' }}>{banner.title}</p>
              {banner.text && <p className="text-xs opacity-90" style={{ color: banner.text_color || '#fff' }}>{banner.text}</p>}
              {banner.product_name && (
                <p className="text-xs mt-1 flex items-center gap-1 opacity-80" style={{ color: banner.text_color || '#fff' }}>
                  <ShoppingCart className="w-3 h-3" />{banner.product_name}
                </p>
              )}
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              {linkTo && (
                <Link to={linkTo} className="flex items-center gap-1 text-xs font-medium px-3 py-1.5 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
                  style={{ color: banner.text_color || '#fff' }}>
                  {banner.product_id ? 'Zum Produkt' : 'Mehr'} <ChevronRight className="w-3 h-3" />
                </Link>
              )}
              <button onClick={() => dismiss(banner.id)}
                className="p-1 rounded-full hover:bg-white/20 transition-colors" style={{ color: banner.text_color || '#fff' }}>
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
          {visible.length > 1 && (
            <div className="flex gap-1 justify-center pb-2">
              {visible.map((b, i) => (
                <div key={`dot-${b.id}`} className={`w-1.5 h-1.5 rounded-full ${i === current % visible.length ? 'bg-white' : 'bg-white/30'}`} />
              ))}
            </div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default PromoBanner;
